(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["support"]) return;
  try {
    
const supportForm=document.querySelector('#KilwinSupportForm');
if(supportForm&&(location.search.includes('contact_posted')||supportForm.querySelector('.errors'))){supportForm.closest('details').open=true;}

  } catch(e) { console.error(e); }
})();
})();
